import store from '@/vuex/store';

const guard = async (from) => {
  if (store.getters.allMenu.includes(from.path)) {
    return true;
  }
  return { path: '404' };
};

const adminRoutes = [
  {
    path: '',
    redirect: () => {
      return '/home';
    },
  },
  {
    path: 'home',
    name: 'dashboard',
    component: () =>
      import(
        /* webpackChunkName: "Dashboard" */ '@/view/manager/home/Home.vue'
      ),
  },
  {
    path: 'settings',
    name: 'settings',
    component: () =>
      import(
        /* webpackChunkName: "Settings" */ '@/view/pages/settings/Settings.vue'
      ),
    children: [
      {
        path: 'profile-settings',
        name: 'profile-settings',
        component: () =>
          import(
            /* webpackChunkName: "Settings" */ '@/view/pages/settings/overview/Profile.vue'
          ),
      },
      {
        path: 'profile-settings/profile',
        name: 'set-profile',
        component: () =>
          import(
            /* webpackChunkName: "Settings" */ '@/view/pages/settings/overview/Profile.vue'
          ),
      },
      {
        path: 'profile-settings/account',
        name: 'set-account',
        component: () =>
          import(
            /* webpackChunkName: "Settings" */ '@/view/pages/settings/overview/Account.vue'
          ),
      },
      {
        path: 'profile-settings/password',
        name: 'set-password',
        component: () =>
          import(
            /* webpackChunkName: "Settings" */ '@/view/pages/settings/overview/Password.vue'
          ),
      },
    ],
  },
  {
    path: 'system',
    name: 'system',
    children: [
      {
        path: 'menu',
        name: 'menu-management',
        beforeEnter: [guard],
        component: () =>
          import(
            /* webpackChunkName: "Manager" */ '@/view/system/menu/Menu.vue'
          ),
      },
      {
        path: 'role',
        name: 'role-management',
        beforeEnter: [guard],
        component: () =>
          import(
            /* webpackChunkName: "Manager" */ '@/view/system/role/Role.vue'
          ),
      },
      {
        path: 'user',
        name: 'user-management',
        beforeEnter: [guard],
        component: () =>
          import(
            /* webpackChunkName: "Manager" */ '@/view/manager/user/User.vue'
          ),
      },
    ],
  },
  {
    path: 'content',
    name: 'content',
    children: [
      {
        path: 'procedure',
        name: 'procedure',
        beforeEnter: [guard],
        component: () =>
          import(
            /* webpackChunkName: "Manager" */ '@/view/manager/procedure/Procedure.vue'
          ),
      },
      {
        path: 'legislation',
        name: 'legislation',
        beforeEnter: [guard],
        component: () =>
          import(
            /* webpackChunkName: "Manager" */ '@/view/manager/legislation/Legislation.vue'
          ),
      },
      {
        path: 'introduce',
        name: 'introduce',
        beforeEnter: [guard],
        component: () =>
          import(
            /* webpackChunkName: "Manager" */ '@/view/manager/introduce/Introduce.vue'
          ),
      },
      {
        path: 'topics',
        name: 'topics',
        beforeEnter: [guard],
        component: () =>
          import(
            /* webpackChunkName: "Manager" */ '@/view/manager/topics/list.vue'
          ),
      },
      {
        path: 'banner',
        name: 'banner',
        beforeEnter: [guard],
        component: () =>
          import(
            /* webpackChunkName: "Manager" */ '@/view/manager/banner/Banner.vue'
          ),
      },
      {
        path: 'article',
        name: 'article',
        children: [
          {
            path: 'management',
            name: 'management',
            beforeEnter: [guard],
            component: () =>
              import(
                /* webpackChunkName: "Manager" */ '@/view/manager/article/article/Article.vue'
              ),
          },
          {
            path: 'approval',
            name: 'approval',
            beforeEnter: [guard],
            component: () =>
              import(
                /* webpackChunkName: "Manager" */ '@/view/manager/article/approval/Approval.vue'
              ),
          },
          {
            path: 'publish',
            name: 'publish',
            beforeEnter: [guard],
            component: () =>
              import(
                /* webpackChunkName: "Manager" */ '@/view/manager/article/publish/Publish.vue'
              ),
          },
        ],
      },
    ],
  },
  {
    path: 'category',
    name: 'category-management',
    beforeEnter: [guard],
    component: () =>
      import(
        /* webpackChunkName: "Manager" */ '@/view/manager/category/Category.vue'
      ),
  },
  {
    path: 'media-files',
    name: 'media-files',
    children: [
      {
        path: 'list-all',
        name: 'list-all',
        beforeEnter: [guard],
        component: () =>
          import(
            /* webpackChunkName: "Manager" */ '@/view/manager/mediafiles/mediafile/MediaFile.vue'
          ),
      },
      {
        path: 'list-approval',
        name: 'list-approval',
        beforeEnter: [guard],
        component: () =>
          import(
            /* webpackChunkName: "Manager" */ '@/view/manager/mediafiles/approval/Approval.vue'
          ),
      },
      {
        path: 'list-publish',
        name: 'list-publish',
        beforeEnter: [guard],
        component: () =>
          import(
            /* webpackChunkName: "Manager" */ '@/view/manager/mediafiles/publish/Publish.vue'
          ),
      },
    ],
  },
  {
    path: 'qa',
    name: 'qa',
    children: [
      {
        path: 'frequently-asked',
        name: 'frequently-asked',
        beforeEnter: [guard],
        component: () =>
          import(
            /* webpackChunkName: "Manager" */ '@/view/manager/qAndA/frequentlyAsked/FrequentlyAsked.vue'
          ),
      },
      {
        path: 'q-and-a',
        name: 'q-and-a',
        beforeEnter: [guard],
        component: () =>
          import(
            /* webpackChunkName: "Manager" */ '@/view/manager/qAndA/qAndA/QAndA.vue'
          ),
      },
    ],
  },
  {
    path: 'config',
    name: 'config',
    children: [
      {
        path: 'majors',
        name: 'majors',
        beforeEnter: [guard],
        component: () =>
          import(
            /* webpackChunkName: "Manager" */ '@/view/manager/document/list.vue'
          ),
      },
      {
        path: 'groups',
        name: 'groups',
        beforeEnter: [guard],
        component: () =>
          import(
            /* webpackChunkName: "Manager" */ '@/view/manager/document/list.vue'
          ),
      },
      {
        path: 'fields',
        name: 'fields',
        beforeEnter: [guard],
        component: () =>
          import(
            /* webpackChunkName: "Manager" */ '@/view/manager/document/list.vue'
          ),
      },
      {
        path: 'types',
        name: 'types',
        beforeEnter: [guard],
        component: () =>
          import(
            /* webpackChunkName: "Manager" */ '@/view/manager/document/list.vue'
          ),
      },
      {
        path: 'agency',
        name: 'agency',
        beforeEnter: [guard],
        component: () =>
          import(
            /* webpackChunkName: "Manager" */ '@/view/manager/document/list.vue'
          ),
      },
    ],
  },
  {
    path: 'recruitment',
    name: 'recruitment-management',
    beforeEnter: [guard],
    component: () =>
      import(
        /* webpackChunkName: "Manager" */ '@/view/manager/recruitment/list.vue'
      ),
  },
  {
    path: 'contact',
    name: 'contact',
    component: () =>
      import(
        /* webpackChunkName: "Manager" */ '@/view/manager/contact/Contact.vue'
      ),
  },
  {
    path: 'case-study',
    name: 'case-study',
    component: () =>
      import(
        /* webpackChunkName: "Manager" */ '@/view/manager/case-study/list.vue'
      ),
  },
];

export default adminRoutes;
